export default __webpack_public_path__ + "static/media/Screenshot_5.6aa80b13.png";